import { displaceRGBA, displaceAmountPx, finishRGBA } from "@erc/shared";

/**
 * Tasarim katmanini fotografa oturtur (yerinde): kirisik -> isik (hard-light +
 * dest-in) -> bitis. Sunucudaki renderMockupComposite ile ayni sira; Studio ve
 * alan editorunun onizlemesi bunu ortak kullanir ki ikisi ayni gorunsun.
 */
export function finishDesignCanvas(
  cv: HTMLCanvasElement,
  opts: { shadeImg?: CanvasImageSource | null; dispImg?: CanvasImageSource | null; displace: number; noise: number },
): void {
  const W = cv.width, H = cv.height;
  const ctx = cv.getContext("2d")!;
  if (opts.dispImg) {
    const dc = document.createElement("canvas");
    dc.width = W; dc.height = H;
    const dctx = dc.getContext("2d")!;
    dctx.drawImage(opts.dispImg, 0, 0, W, H);
    const cur = ctx.getImageData(0, 0, W, H);
    cur.data.set(displaceRGBA(cur.data, dctx.getImageData(0, 0, W, H).data, W, H, displaceAmountPx(opts.displace, W, H)));
    ctx.putImageData(cur, 0, 0);
  }
  if (opts.shadeImg) {
    const lit = document.createElement("canvas");
    lit.width = W; lit.height = H;
    const lctx = lit.getContext("2d")!;
    lctx.drawImage(cv, 0, 0);
    lctx.globalCompositeOperation = "hard-light";
    lctx.drawImage(opts.shadeImg, 0, 0, W, H);
    // Saydam yerlere sizan gri: tasarimin kendi alfasina geri kirp
    lctx.globalCompositeOperation = "destination-in";
    lctx.drawImage(cv, 0, 0);
    ctx.clearRect(0, 0, W, H);
    ctx.drawImage(lit, 0, 0);
  }
  const img = ctx.getImageData(0, 0, W, H);
  finishRGBA(img.data, W, H, opts.noise);
  ctx.putImageData(img, 0, 0);
}

/** Beyaz/siyah maske -> beyazin alfa oldugu tuval (destination-in icin) */
export function maskToAlpha(src: CanvasImageSource, W: number, H: number): HTMLCanvasElement {
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d")!;
  ctx.drawImage(src, 0, 0, W, H);
  const d = ctx.getImageData(0, 0, W, H);
  for (let i = 0; i < d.data.length; i += 4) {
    d.data[i + 3] = Math.round((d.data[i + 3] * d.data[i]) / 255);
    d.data[i] = 255; d.data[i + 1] = 255; d.data[i + 2] = 255;
  }
  ctx.putImageData(d, 0, 0);
  return c;
}

/** Yuzey maskesinin (maskToAlpha ciktisi) sekilli alani kapsama orani — 40x40 ornek,
 *  elips yaklasimi. Sekilli alanda %85'in altindaysa maske bozuk sayilir ve kirpma
 *  yapilmaz (sunucudaki clipToSurface ile ayni kural; AI segmentasyonu urunu
 *  kurdele cizgisinden ikiye bolebiliyor). */
export const SURFACE_MIN_COVER = 0.85;
export function surfaceCover(mask: HTMLCanvasElement, a: { x: number; y: number; width: number; height: number; rotation?: number }): number {
  const ctx = mask.getContext("2d");
  if (!ctx) return 1;
  const rad = ((a.rotation || 0) * Math.PI) / 180, cos = Math.cos(rad), sin = Math.sin(rad);
  let inside = 0, covered = 0;
  for (let i = 0; i < 40; i++) for (let j = 0; j < 40; j++) {
    const u = (i + 0.5) / 40, v = (j + 0.5) / 40;
    if ((u - 0.5) ** 2 + (v - 0.5) ** 2 > 0.2) continue; // elipsin icinde kalan ornekler (kenar payli)
    const lx = u * a.width, ly = v * a.height;
    const px = Math.round(a.x + lx * cos - ly * sin), py = Math.round(a.y + lx * sin + ly * cos);
    if (px < 0 || py < 0 || px >= mask.width || py >= mask.height) continue;
    inside++;
    if (ctx.getImageData(px, py, 1, 1).data[3] >= 128) covered++;
  }
  return inside ? covered / inside : 1;
}

